import { render } from "./ListInvoice.vue?vue&type=template&id=734662be"
import script from "./ListInvoice.vue?vue&type=script&lang=js"
export * from "./ListInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__